import React, { useEffect, useState } from "react";
import { bool, shape, arrayOf, string } from "prop-types";
import { push, replace } from "connected-react-router";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import * as i18nUtils from "util/i18n";
import * as configUtils from "util/config";
import { connect, useDispatch, useSelector } from "react-redux";
import { selectors as environmentSelectors, actions as environmentActions } from "reducers/environment";
import { selectors as onboardingSelectors, actions as onboardingActions } from "reducers/onboarding";
import { actions as notificationActions } from "reducers/notification";
import { actions as modalActions } from "reducers/modal";
import GridTable from "pages/_components/GridTable/GridTable";

import MainContainer from "pages/_components/MainContainer";
import Head from "pages/_components/Head";
import Button from "pages/_components/Button";
import TextField from "pages/_components/fields/TextField";
import I18n from "pages/_components/I18n";
import ErrorPopup from "pages/_components/ErrorPopup";
import Selector from "pages/_components/fields/formik/Selector";
import CustomText from "pages/_components/CustomText/CustomText";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import Notification from "pages/_components/Notification";
import CustomData from "pages/_components/CustomData/CustomData";
import HeaderSimple from "pages/_components/HeaderSimple/HeaderSimple";
import { isIOS } from "react-device-detect";
import EnvironmentSignerSlide from "../_components/EnvironmentSignerSlide";
import EnvironmentStepper from "../_components/EnvironmentStepper";
import EnvironmentHelpSlide from "../_components/EnvironmentHelpSlide";
import EnvironmentWelcomeSlide from "../_components/EnvironmentWelcomeSlide";
import EnvironmentExitSlide from "../_components/EnvironmentExitSlide";
import Uploader from "../_components/Uploader";
import { useHistoricData } from "../hooks/useHistoricData";

const FORM_ID = "environment.step.shareholders";
const PAGE_ID = "StepShareholders";
const DELETE_NOTIFICATION_SCOPE = "deleteShareholder";
const ROLE = "SOCIO_ACCIONISTA";

const StepShareholders = ({
    isMobile,
    shareholdersBackup,
    shareholdersRequest,
    nosisCdaRequest,
    cuit,
    fetching,
    onboardingMainRole,
    isDesktop,
}) => {
    const dispatch = useDispatch();
    const { role = "" } = useSelector((state) => state.onboarding.userRoleRequest.value);
    const isLegalRepresentative = onboardingMainRole === "REPRESENTANTE_LEGAL";
    const { status: shareholdersRequestStatus, error: shareholdersRequestError } = shareholdersRequest;
    const {
        status: nosisCdaRequestStatus,
        value: nosisCdaRequestValue,
        error: nosisCdaRequestError,
        id: nosisCdaRequestId,
    } = nosisCdaRequest;
    const [isOwner, setIsOwner] = useState(false);
    const [error, setError] = useState("");
    const [helpIsVisible, setHelpIsVisible] = useState(false);
    const [exitMsgIsVisible, setExitMsgIsVisible] = useState(false);
    const [welcomeMsgIsVisible, setWelcomeMsgIsVisible] = useState(false);
    const [signerSliderIsVisible, setSignerSliderIsVisible] = useState(false);
    const [legalPersonCriteria, setLegalPersonCriteria] = useState([]);

    const [shareholders, setShareholders] = useState([]);

    const [thubanCodeRegistroAccionario, setThubanRegistroAccionario] = useState("");

    const [capitalHoldingMaxLength, setCapitalHoldingMaxLength] = useState(5);

    useEffect(() => {
        const maxLength = configUtils.getInteger("onboarding.capitalHolding.maxLength", 5);
        setCapitalHoldingMaxLength(maxLength);

        dispatch(onboardingActions.listPersonalInfoRequest(false));
        dispatch(onboardingActions.listRegulatoryInfoRequest());
    }, []);

    useEffect(() => {
        if (!role) {
            dispatch(onboardingActions.getUserRole());
        }
    }, [dispatch]);

    useEffect(() => {
        const registroAccionarioCode = configUtils.get("onboarding.thuban.code.acta_registro_accionario", "0011");
        setThubanRegistroAccionario(registroAccionarioCode);
    }, []);

    useEffect(() => {
        if (shareholdersBackup?.shareholders.length > 0) {
            setShareholders(shareholdersBackup?.shareholders);
        }
    }, [shareholdersBackup?.shareholders]);

    useEffect(() => {
        if (cuit == null) {
            dispatch(onboardingActions.legalRepresentativeInfoRequest());
        } else {
            dispatch(
                onboardingActions.getNosisCda({
                    documentNumber: cuit,
                    documentType: "CUIT",
                    personType: "LEGAL_PERSON",
                }),
            );
        }
    }, []);

    useEffect(() => {
        if (cuit !== null) {
            dispatch(
                onboardingActions.getNosisCda({
                    documentNumber: cuit,
                    documentType: "CUIT",
                    personType: "LEGAL_PERSON",
                }),
            );
        }
    }, [cuit]);

    const noBackupData = shareholdersBackup?.hasShareRegister === undefined;
    const { getBackupDataByStepId } = useHistoricData(!noBackupData);

    useEffect(() => {
        if (shareholdersRequestStatus === "SUCCESS") {
            dispatch(environmentActions.setShareholdersRequest(""));
            dispatch(push("/environment/stepProxies"));
            getBackupDataByStepId("stepProxies");
        } else if (shareholdersRequestStatus === "FAILURE") {
            dispatch(push("/environment/stepError"));
            // return;
            // setError(shareholdersRequestError);
            // dispatch(modalActions.modalShow());
            // dispatch(environmentActions.setShareholdersRequest(""));
        }
    }, [shareholdersRequestStatus, shareholdersRequestError]);

    useEffect(() => {
        if (nosisCdaRequestId === cuit) {
            if (nosisCdaRequestStatus === "SUCCESS") {
                // const nosisCdaValue = nosisCdaRequestValue?.find((criteria) => criteria?.name === "CDA")?.value;
                // if (
                //     !!nosisCdaValue &&
                //     nosisCdaValue === "Aprobado" &&
                //     onboardingMainRole.toUpperCase() === "PROPIETARIO"
                // ) {
                //     setIsOwner(true);
                // }
                if (onboardingMainRole === "PROPIETARIO") {
                    setIsOwner(true);
                }
                setLegalPersonCriteria(nosisCdaRequestValue);
                dispatch(onboardingActions.resetNosisCda());
            } else if (nosisCdaRequestStatus === "FAILURE" && nosisCdaRequestError === "returnCode.BAK612W") {
                dispatch(
                    notificationActions.showNotification(
                        i18nUtils.get(
                            "returnCode.BAK589W",
                            "Se produjo un error en el sistema, por favor intente nuevamente",
                        ),
                        "error",
                        ["environment"],
                    ),
                );

                setTimeout(() => {
                    dispatch(onboardingActions.resetNosisCda());
                    dispatch(push("/"));
                }, 2500);
            }
        }
    }, [nosisCdaRequestStatus, nosisCdaRequestValue, nosisCdaRequestError, nosisCdaRequestId]);

    const validCapitalHolding = (ownerPercentage) => {
        let sum = 0;
        if (isOwner) {
            sum = Number(ownerPercentage);
        }
        for (let i = 0; i < shareholders.length; i++) {
            sum += Number(shareholders[i].capitalHolding);
        }
        if (isOwner || shareholders.length > 0) {
            return sum > 0 && sum <= 100;
        }
        return true;
    };

    const submitIsAllowed = ({ values }) => {
        const { ownerPercentage, hasShareRegister, shareRegisterIDU } = values;
        const firstFieldsAreValid =
            (!isOwner || !!ownerPercentage) &&
            (hasShareRegister === "false" || !!shareRegisterIDU) &&
            validCapitalHolding(ownerPercentage);
        return firstFieldsAreValid;
    };

    const onHeaderBack = () => {
        if (isLegalRepresentative) {
            getBackupDataByStepId("stepTaxData");
            dispatch(replace("/environment/stepTaxData"));
        } else {
            getBackupDataByStepId("stepLegalRepresentative");
            dispatch(replace("/environment/stepLegalRepresentative"));
        }
    };

    const submitSignerSlider = (values) => {
        setShareholders((prevSigners) => [...prevSigners, { ...values }]);
    };

    const requiredString = i18nUtils.get("forms.inputFile.massivePayments.invalid.required");
    const formikProps = {
        validateOnChange: false,
        validateOnBlur: false,
        initialValues: {
            ownerPercentage: shareholdersBackup?.ownerPercentage || "",
            signer: !shareholdersBackup?.signer && shareholdersBackup?.signer !== undefined ? "false" : "true",
            hasShareRegister:
                !shareholdersBackup?.hasShareRegister && shareholdersBackup?.hasShareRegister !== undefined
                    ? "false"
                    : "true",
            shareRegisterIDU: shareholdersBackup?.shareRegisterIDU || "",
            shareRegisterIDUName: shareholdersBackup?.shareRegisterIDUName || "",
        },
        validationSchema: () =>
            Yup.object().shape({
                ownerPercentage: isOwner
                    ? Yup.string().test(
                          "less-than-100",
                          i18nUtils.get("forms.inputFile.massivePayments.invalid.field"),
                          (value) => !!value && !Number.isNaN(value) && validCapitalHolding(value),
                      )
                    : "",
                signer: Yup.string().required(requiredString),
                hasShareRegister: Yup.string().required(requiredString),
                shareRegisterIDU: Yup.string().when("hasShareRegister", {
                    is: "true",
                    then: Yup.string().required(requiredString),
                }),
            }),
        onSubmit: (values) => {
            if (values) {
                const finalValues = {
                    ownerPercentage: values?.ownerPercentage,
                    signer: true,
                    hasShareRegister: values?.hasShareRegister === "true",
                    shareRegisterIDU: values?.shareRegisterIDU,
                    shareRegisterIDUName: values?.shareRegisterIDUName,
                    shareholders,
                    legalPersonCriteria,
                };
                dispatch(environmentActions.setShareholdersBackup(finalValues));
                dispatch(environmentActions.saveShareholders(finalValues));
            }
        },
    };

    const [columns, setColumns] = useState([]);

    useEffect(() => {
        const distributeShareholders = () => {
            const newColumns = [];
            shareholders.forEach((shareholder, index) => {
                const columnIndex = index % 2;
                if (!newColumns[columnIndex]) {
                    newColumns[columnIndex] = [];
                }
                newColumns[columnIndex].push(shareholder);
            });
            setColumns(newColumns);
        };

        distributeShareholders();
    }, [shareholders]);

    const handleDelete = (shareholder) => {
        dispatch(
            environmentActions.deleteShareholders(
                shareholder.documentNumber,
                ROLE,
                setShareholders,
                DELETE_NOTIFICATION_SCOPE,
            ),
        );
    };

    return (
        <>
            <Notification scopeToShow="environment" />
            <Notification scopeToShow={DELETE_NOTIFICATION_SCOPE} />
            {isMobile ? (
                <Head
                    titleText={i18nUtils.get("legalPerson.title", "Registro")}
                    onBack={onHeaderBack}
                    hideNavbarInMobile
                    tooltipMobile
                    onClickTooltip={() => setHelpIsVisible(true)}
                    tooltipImage={isIOS ? "images/figma/icon/help-white.svg" : "images/figma/icon/help.svg"}
                    showCenterContent
                />
            ) : (
                <HeaderSimple inverse />
            )}
            <MainContainer
                showLoader={(fetching || nosisCdaRequestStatus === "FETCHING") && !signerSliderIsVisible}
                className="onboarding">
                <EnvironmentStepper isMobile={isMobile} page="StepShareholders" />
                <div className="step">
                    {isMobile && <I18n id="environment.shareholders.title" defaultValue="Socios" component="h1" />}
                    {!isMobile && (
                        <Head
                            titleText={i18nUtils.get("", "Socios")}
                            onBack={onHeaderBack}
                            tooltip
                            showCenterContent
                            onClickTooltip={() => setHelpIsVisible(true)}
                            tooltipImage="images/figma/icon/help.svg"
                        />
                    )}
                    <Formik {...formikProps}>
                        {(allFormik) => (
                            <Form>
                                <div className="grid-table grid-table-form">
                                    <div className="grid-table-row grid-cols-12">
                                        {/* // White card */}
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            {isOwner && (
                                                <Field
                                                    component={TextField}
                                                    idForm={FORM_ID}
                                                    name="ownerPercentage"
                                                    id="ownerPercentage"
                                                    maxLength={capitalHoldingMaxLength}
                                                    labelTextDefault={i18nUtils.get("", "Tu porcentaje de tenencia")}
                                                    hidePlaceholder
                                                    isDouble
                                                    autoFocus
                                                />
                                            )}
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n
                                                id=""
                                                defaultValue={i18nUtils.get("", "¿Posee registro accionario?")}
                                            />
                                            <Field
                                                inLineControl
                                                component={Selector}
                                                renderAs="radio"
                                                idForm={FORM_ID}
                                                name="hasShareRegister"
                                                options={[
                                                    {
                                                        id: "true",
                                                        label: i18nUtils.get("global.yes", "Sí"),
                                                    },
                                                    {
                                                        id: "false",
                                                        label: i18nUtils.get("global.no", "No"),
                                                    },
                                                ]}
                                            />
                                            {allFormik.values.hasShareRegister === "true" && (
                                                <Field
                                                    component={Uploader}
                                                    idForm={FORM_ID}
                                                    name="shareRegisterIDU"
                                                    label={i18nUtils.get("", "Última acta de registro accionario")}
                                                    documentCode={thubanCodeRegistroAccionario}
                                                    defaultDocument={{
                                                        documentId: shareholdersBackup?.shareRegisterIDU,
                                                        documentName: shareholdersBackup?.shareRegisterIDUName,
                                                    }}
                                                    withDocumentName
                                                />
                                            )}
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            {/* <I18n
                                                id=""
                                                defaultValue={i18nUtils.get(
                                                    "",
                                                    "¿Formarás parte del esquema de firmas?",
                                                )}
                                            />
                                            <Field
                                                inLineControl
                                                component={Selector}
                                                renderAs="radio"
                                                idForm={FORM_ID}
                                                name="signer"
                                                options={[
                                                    {
                                                        id: "true",
                                                        label: i18nUtils.get("global.yes", "Sí"),
                                                    },
                                                    {
                                                        id: "false",
                                                        label: i18nUtils.get("global.no", "No"),
                                                    },
                                                ]}
                                            /> */}
                                            <I18n id="" defaultValue={i18nUtils.get("", "Declará tus socios")} />
                                            <div className="box transparent box-border-dashed flex">
                                                <Button
                                                    className="btn-secondary icon-medium btn-only-icon enphasize"
                                                    image="plus.svg"
                                                    block={false}
                                                />
                                                <Button
                                                    onClick={() => setSignerSliderIsVisible(true)}
                                                    bsStyle="link"
                                                    className="text-left"
                                                    block={false}>
                                                    <CustomText text={i18nUtils.get("", "Agregá socios")} />
                                                </Button>
                                            </div>
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <div className="md:flex md:gap-4 md:basis-1/2">
                                                {columns.map((column) => (
                                                    <div
                                                        key={column[0]?.documentNumber}
                                                        className="md:w-1/2 onboarding-container-stake">
                                                        <GridTable>
                                                            <GridTable.Body>
                                                                {column.map((shareholder) => (
                                                                    <GridTable.Container
                                                                        key={shareholder?.documentNumber}
                                                                        className="box shadow onboarding-grid-display"
                                                                        columns={2}
                                                                        columnsTemplate="90% 10%">
                                                                        <GridTable.Data columnStart={1} rowStart={1}>
                                                                            <CustomData
                                                                                titleText={i18nUtils.get("", "CUIT")}
                                                                                titleTextType="TEXT"
                                                                                valueText={shareholder?.documentNumber}
                                                                                valueTextType="TEXT"
                                                                            />
                                                                        </GridTable.Data>
                                                                        <GridTable.Data columnStart={1} rowStart={2}>
                                                                            <CustomData
                                                                                titleText={i18nUtils.get("", "Celular")}
                                                                                titleTextType="TEXT"
                                                                                valueText={`+${shareholder?.phoneNumber?.countryCode}${shareholder?.phoneNumber?.areaCode}${shareholder?.phoneNumber?.value}`}
                                                                                valueTextType="TEXT"
                                                                            />
                                                                        </GridTable.Data>
                                                                        <GridTable.Data columnStart={1} rowStart={3}>
                                                                            <CustomData
                                                                                titleText={i18nUtils.get("", "Email")}
                                                                                titleTextType="TEXT"
                                                                                valueText={shareholder?.email}
                                                                                valueTextType="TEXT"
                                                                            />
                                                                        </GridTable.Data>
                                                                        <GridTable.Data
                                                                            columnStart={2}
                                                                            rowStart={1}
                                                                            className={
                                                                                isDesktop &&
                                                                                "onboarding-button-shereholder"
                                                                            }>
                                                                            <CustomButton
                                                                                icon="images/figma/icon/menu-mobile.svg"
                                                                                options={[
                                                                                    {
                                                                                        func: () =>
                                                                                            handleDelete(shareholder),
                                                                                        text: "global.delete",
                                                                                        textType: "I18N",
                                                                                    },
                                                                                ]}
                                                                            />
                                                                        </GridTable.Data>
                                                                    </GridTable.Container>
                                                                ))}
                                                            </GridTable.Body>
                                                        </GridTable>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid-table form-actions">
                                    <div className="grid-table-row sm:flex md:grid-cols-12">
                                        <div className="grid-table-data md:col-start-5 md:col-span-4">
                                            <Button
                                                bsStyle="primary"
                                                label="global.continue"
                                                loading={shareholdersRequestStatus === "FETCHING" || fetching}
                                                type="submit"
                                                block
                                                disabled={!submitIsAllowed(allFormik)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </MainContainer>

            <EnvironmentSignerSlide
                slideIsVisible={signerSliderIsVisible}
                closeSlide={() => setSignerSliderIsVisible(false)}
                onSubmit={submitSignerSlider}
                shareholders={shareholders}
                owner={
                    document.getElementById("ownerPercentage")
                        ? Number(document.getElementById("ownerPercentage").value)
                        : 0
                }
                isOwner={isOwner}
                isMobile={isMobile}
                notCreateInRoot
            />
            <EnvironmentHelpSlide
                slideIsVisible={helpIsVisible}
                closeSlide={() => setHelpIsVisible(false)}
                isMobile={isMobile}
                page={PAGE_ID}
            />
            <EnvironmentWelcomeSlide
                slideIsVisible={welcomeMsgIsVisible}
                closeSlide={() => setWelcomeMsgIsVisible(false)}
                isMobile={isMobile}
            />
            <EnvironmentExitSlide
                slideIsVisible={exitMsgIsVisible}
                closeSlide={() => setExitMsgIsVisible(false)}
                isMobile={isMobile}
            />
            <ErrorPopup error={error} handleClick={() => dispatch(modalActions.modalClose())} />
        </>
    );
};

StepShareholders.propTypes = {
    isMobile: bool.isRequired,
    shareholdersBackup: arrayOf(shape({})).isRequired,
    shareholdersRequest: arrayOf(shape({})).isRequired,
    nosisCdaRequest: arrayOf(shape({})).isRequired,
    cuit: string.isRequired,
    fetching: bool.isRequired,
    onboardingMainRole: string.isRequired,
    isDesktop: bool.isRequired,
};

const mapStateToProps = (state) => ({
    shareholdersBackup: environmentSelectors.getShareholdersBackup(state),
    shareholdersRequest: environmentSelectors.getShareholdersRequest(state),
    nosisCdaRequest: onboardingSelectors.getNosisCdaRequest(state),
    cuit: onboardingSelectors.getCuitUser(state),
    fetching: onboardingSelectors.getFetching(state),
    onboardingMainRole: onboardingSelectors.getOnboardingMainRole(state),
});

export default connect(mapStateToProps)(StepShareholders);
